<template>
  <div class="error">
    <div class="error__icon">
      <img src="@/assets/images/screen-error.svg" />
    </div>
    <span class="error__title"> {{ errorTitle }} </span>
    <span class="error__subtitle"> {{ errorSubtitle }} </span>
    <div class="error__buttons">
      <button
        v-if="displaySecondaryErrorButton"
        class="secondary"
        @click="secondaryErrorButtonFunction"
      > {{ secondaryErrorButtonText }}</button>
      <button
        v-if="displayPrimaryErrorButton"
        class="primary"
        @click="primaryErrorButtonFunction"
      > {{ primaryErrorButtonText }}</button>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';

export default {
  props: {
    errorTitle: {
      type: String,
      require: false,
    },
    errorSubtitle: {
      type: String,
      require: false,
    },
    displayPrimaryErrorButton: {
      type: Boolean,
      require: true,
    },
    primaryErrorButtonText: {
      type: String,
      require: false,
    },
    displaySecondaryErrorButton: {
      type: Boolean,
      require: true,
    },
    secondaryErrorButtonText: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      i18n,
    };
  },
  methods: {
    primaryErrorButtonFunction() {
      this.$emit('primaryErrorButtonFunction');
    },
    secondaryErrorButtonFunction() {
      this.$emit('secondaryErrorButtonFunction');
    },
  },
};
</script>

<style lang="scss">
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  position: absolute;
  top: 71px;
  width: 100%;
  min-height: 90%;
  background: #F7F9FA;

  &__title {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 120%;
    text-align: center;
    color: #32363B;
    margin-bottom: 24px;
  }

  &__subtitle {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 120%;
    text-align: center;
    color: #32363B;
    max-width: 824px;
    margin-bottom: 48px;
  }

  &__icon {
    margin-bottom: 48px;
  }

  &__buttons {
    display: flex;
    gap: 15px;

    button {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      border-radius: 4px;
      width: 175px;
      height: 40px;
      border: none;
    }
    .primary {
      background: #5981E3;
      color: #FFFFFF;
    }
    .secondary {
      background: #F7F9FA;
      color: #32363B;
      border: 1px solid;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/Status/components/Error.vue